(() => {
  const instances = new WeakMap();
  function init(root) {
    root.querySelectorAll('[data-occasions]').forEach(section => {
      if (instances.has(section)) return;
      const controller = new AbortController(), options = { signal: controller.signal };
      const viewport = section.querySelector('[data-occasion-viewport]');
      const slides = [...section.querySelectorAll('[data-occasion-slide]')];
      const dots = [...section.querySelectorAll('[data-occasion-index]')];
      const status = section.querySelector('[data-occasion-status]');
      const carousel = section.querySelector('.lt-occasions__carousel');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0, timer, frame, visible = false, hovered = false, interacting = false;
      let pendingAnnouncement = false;
      function schedule() {
        clearTimeout(timer);
        if (reduce.matches || !visible || hovered || interacting || document.hidden || carousel.contains(document.activeElement)) return;
        timer = setTimeout(() => { go(current + 1, false); schedule(); }, 4500);
      }
      function paint() {
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
        if (pendingAnnouncement) {
          status.textContent = slides[current].getAttribute('aria-label');
          pendingAnnouncement = false;
        }
      }
      function go(index, manual = true) {
        const target = (index + slides.length) % slides.length;
        pendingAnnouncement = manual;
        viewport.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft, behavior: reduce.matches ? 'instant' : 'smooth' });
        schedule();
      }
      viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          current = Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / viewport.clientWidth)));
          paint();
          schedule();
        });
      }, { ...options, passive: true });
      section.querySelector('[data-occasion-prev]').addEventListener('click', () => go(current - 1), options);
      section.querySelector('[data-occasion-next]').addEventListener('click', () => go(current + 1), options);
      dots.forEach(dot => dot.addEventListener('click', () => go(Number(dot.dataset.occasionIndex)), options));
      viewport.addEventListener('keydown', event => {
        const moves = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: slides.length - 1 };
        if (!(event.key in moves)) return;
        event.preventDefault(); go(moves[event.key]);
      }, options);
      carousel.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; schedule(); } }, options);
      carousel.addEventListener('pointerleave', () => { hovered = false; schedule(); }, options);
      viewport.addEventListener('pointerdown', () => { interacting = true; pendingAnnouncement = true; schedule(); }, { ...options, passive: true });
      window.addEventListener('pointerup', () => { interacting = false; schedule(); }, options);
      window.addEventListener('pointercancel', () => { interacting = false; schedule(); }, options);
      carousel.addEventListener('focusin', schedule, options);
      carousel.addEventListener('focusout', () => queueMicrotask(schedule), options);
      document.addEventListener('visibilitychange', schedule, options);
      reduce.addEventListener('change', () => {
        if (reduce.matches) viewport.scrollTo({ left: current * viewport.clientWidth, behavior: 'instant' });
        schedule();
      }, options);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25; schedule(); }, { threshold: .25 });
      observer.observe(carousel);
      const resize = new ResizeObserver(() => viewport.scrollTo({ left: current * viewport.clientWidth, behavior: 'instant' }));
      resize.observe(viewport);
      section.querySelector('[data-occasion-controls]').hidden = false;
      paint();
      instances.set(section, () => { controller.abort(); observer.disconnect(); resize.disconnect(); clearTimeout(timer); cancelAnimationFrame(frame); });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-occasions]').forEach(section => { instances.get(section)?.(); instances.delete(section); }));
})();
